import { Bleedable, MarginBox, Paragraph, Separator } from '@fs/zion-ui'
import React from 'react'
import { Person } from '@fs/zion-person'
import { useTranslation } from 'react-i18next'
import { AddChildButton } from '@fs/zion-add-find-flow'
import { css } from '@emotion/core'
import CoupleWrapper from './CoupleWrapper'
import ChildrenWrapper from './ChildrenWrapper'
import ChildrenListSkeleton from '../children-list/ChildrenListSkeleton'

const childButtonCss = css`
  & > button {
    margin: 0 -8px;
    padding-inline-start: 8px;
    padding-inline-end: 8px;
  }
`

// TODO make PersonRow support loading state and use that instead of Person component

export default function FamilySkeleton(): JSX.Element {
  const [t] = useTranslation()
  return (
    <div>
      <CoupleWrapper>
        <MarginBox marginY="nano">
          <MarginBox marginY="nano">
            <Person loading avatarSize="smaller" />
          </MarginBox>

          <MarginBox marginY="nano">
            <Person loading avatarSize="smaller" />
          </MarginBox>
        </MarginBox>
      </CoupleWrapper>

      <ChildrenWrapper>
        <Bleedable top={8} bottom={8}>
          <Paragraph size="sm">{t('tree-person.children.label')}</Paragraph>
        </Bleedable>
        <Separator size="nano" />
        <ChildrenListSkeleton count={3} />
        <Separator size="nano" />
        <div css={childButtonCss}>
          {/* eslint-disable-next-line test-selectors/button -- NA */}
          <AddChildButton disabled />
        </div>
      </ChildrenWrapper>
    </div>
  )
}
